"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductAttestationCardType = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const getProductAttestationCardType = (item) => {
    var _a, _b, _c;
    const productType = item.productType || ((_a = item === null || item === void 0 ? void 0 : item.productDetails) === null || _a === void 0 ? void 0 : _a.productType);
    const attestation = (_c = (_b = item.variant.attributes) === null || _b === void 0 ? void 0 : _b.attestationRequired) === null || _c === void 0 ? void 0 : _c.key;
    if (productType !== mxp_schemas_1.Product.ProductType.CONTRIBUTION || !attestation) {
        return null;
    }
    switch (attestation) {
        case mxp_schemas_1.Product.DonationAttestation.YES:
            return mxp_schemas_1.Product.DonationCardType.PERSONAL;
        case mxp_schemas_1.Product.DonationAttestation.NO:
            return mxp_schemas_1.Product.DonationCardType.CORPORATE;
    }
};
exports.getProductAttestationCardType = getProductAttestationCardType;
exports.default = exports.getProductAttestationCardType;
//# sourceMappingURL=getProductAttestationCardType.js.map